import { render, staticRenderFns } from "./resignation-modal.vue?vue&type=template&id=41d683b4"
import script from "./resignation-modal.vue?vue&type=script&lang=js"
export * from "./resignation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports